import { apolloClient } from '~/apollo';
import { GET_USER_LIST_STATISTICS } from '~/graphql/queries';

export const getUserListStatistics = async (): Promise<any> => {
  return apolloClient.query({
    query: GET_USER_LIST_STATISTICS,
    fetchPolicy: 'network-only',
  });
};
